<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-09-06 15:03:59
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftPropertyGroup\editShiftPropertyGroup.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_shiftPropertyGroup_form_editTitle')
        : $t('label_essweb_shiftPropertyGroup_form_viewTitle')
    "
    widthClass="max-1000"
    pad="0"
    delBtn
    :editBtn="!iSEdited"
    :initData="ShiftPGData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'shift_property_group_name',
      'shift_property_group_description',
      'shift_property_group_code',
      'remarks',
    ]"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_shiftPropertyGroup_list_title')).then(
        (res) => {
          res ? toDelete() : null;
        }
      )
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="ShiftPGData.shift_property_group_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      ShiftPGData.shift_property_group_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_shiftPropertyGroup_form_shiftPropertyGroupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="ShiftPGData.shift_property_group_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      ShiftPGData.shift_property_group_description = valueArr;
                    }
                  "
                  :label="
                    $t('label_essweb_shiftPropertyGroup_form_descriptionLabel')
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :readonly="!iSEdited"
                  maxlength="100"
                  :label="
                    $t(
                      'label_essweb_shiftPropertyGroup_form_shiftPropertyGroupCodeLabel'
                    )
                  "
                  v-model="ShiftPGData.shift_property_group_code"
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_shiftPropertyGroup_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  :filled="iSEdited"
                  dense
                  counter="500"
                  single-line
                  :readonly="!iSEdited"
                  v-model="ShiftPGData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <PropertyList
            :items="desserts"
            :listdata="PropertyListData"
            @edit="
              (obj) => {
                viewProperty = false;
                toEditProperty(obj);
              }
            "
            @view="
              (obj) => {
                viewProperty = true;
                toEditProperty(obj);
              }
            "
            :canEdit="iSEdited"
          />
        </template>
      </Taber>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <EditMappingPopup
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        :curGroupId="$route.params.id"
        :view="viewProperty"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
        @confirm="onEditProperty"
      />
    </template>
    <!-- tools end -->
  </ContentLayout>
</template>
<script>
import EditMappingPopup from "@/Page/EssAdmin/Shift/ShiftPropertyGroup/components/EditMappingPopup";
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "editShiftPG",
  components: { EditMappingPopup },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      showMappingPopup: false,
      PropertyListData: null,
      isChanged: false,
      PropertyData: null,
      viewProperty: false,
      curTab: "tab-1",
      taber: [
        "label_essweb_shiftPropertyGroup_form_step_generalLabel",
        "label_essweb_shiftPropertyGroup_form_step_propertyLabel",
      ],
      selected: [],
      iSEdited: true,
      ShiftPGData: {
        shift_property_group_name: "",
        shift_property_group_description: "",
        shift_property_group_code: "",
        remarks: "",
      },
      desserts: [],
    };
  },
  mounted() {
    const that = this;
    this.getShiftPGDetail();
    this.getPropertyList();
  },
  methods: {
    getShiftPGDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property_group",
        url: "/shift-property-group/get-shift-property-group-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        res.data["shift_property_group_name_save"] =
          res.data.shift_property_group_name;
        res.data.shift_property_group_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.shift_property_group_name
        );
        res.data["shift_property_group_description_save"] =
          res.data.shift_property_group_description;
        res.data.shift_property_group_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.shift_property_group_description
          );
        that.ShiftPGData = res.data;
      });
    },
    getPropertyList: function (type) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property",
        url: "/shift-property/get-shift-property-list/",
        data: {
          shift_property_group_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          item["show_text"] = "";
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        // JSON.parse(JSON.stringify());
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    onEditProperty: function (obj, deleteArr, changeList) {
      const that = this;
      this.PropertyData = null;
      that.showMappingPopup = false;
      // obj["changeList"].map(
      //   (item) =>
      //     (item["shift_property_group_code"] =
      //       that.PropertyGroupData.shift_property_group_code)
      // );
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property_group",
        url: "/shift-property-group/update-shift-property-group-table/",
        data: {
          uuid: this.$route.params.id,
          propertyIds: deleteArr.length ? deleteArr.join(",") : "",
          ess_att_shift_property: changeList,
        },
      }).then((res) => {
        that.findTreeItem(that.desserts, obj.property_master_code, changeList);
      });
    },
    findTreeItem: function (tree, code, obj) {
      const that = this;
      tree.some((item) => {
        if (item["property_master_code"] === code) {
          item["changeList"] = obj;
          if (item["changeList"].length == 0) {
            item["value"] = "";
          }
          return true;
        } else {
          if (item.children) {
            that.findTreeItem(item.children, code, obj);
          } else {
          }
        }
      });
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            this.$router.back();
          }
        });
      else {
        this.$router.back();
      }
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property_group",
        url: "/shift-property-group/delete-shift-property-group-table/",
        data: { uuids: this.$route.params.id },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shiftPropertyGroup_list_deleteShiftPropertyGroupSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property_group",
        url: "/shift-property-group/update-shift-property-group-table/",
        data: {
          uuid: this.$route.params.id,
          shift_property_group_name: this.$transCommonLangKey(
            this.ShiftPGData.shift_property_group_name,
            this.ShiftPGData.shift_property_group_name_save
          ),
          shift_property_group_description: this.$transCommonLangKey(
            this.ShiftPGData.shift_property_group_description,
            this.ShiftPGData.shift_property_group_description_save
          ),
          shift_property_group_code: this.ShiftPGData.shift_property_group_code,
          remarks: this.ShiftPGData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_shiftPropertyGroup_list_updateShiftPropertyGroupSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
